module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/92c49e9013cb1c9fba9b5fe3a99b011f.png";